export default __webpack_public_path__ + "static/media/vitalik shirt.31a8e311.png";